import {useEffect, useState} from "react";
import {CompanyEntity} from "../model/company";
import {InvoiceGroupingDefault, InvoiceGroupingDefaultEntity} from "../model/invoice-grouping-default";
import {RateModelEntity} from "../model/rate-model";
import {useOtsSelector} from "./useOtsSelector";
import {getCurrentRegionId} from "../store/entity/region/selectors";

export type UseInvoiceGroupingDefaultsProps = {
  operator?: CompanyEntity;
  truckCompany?: CompanyEntity;
  rateModel?: RateModelEntity
}

export type UseInvoiceGroupingDefaultsResult = {
  invoiceGroupings?: InvoiceGroupingDefault[]
}

const findDefaults = (
  company: CompanyEntity,
  rateModel: RateModelEntity,
  regionId: string
): InvoiceGroupingDefaultEntity[] | undefined => {
  let invoiceGroupings: InvoiceGroupingDefaultEntity[] | undefined = undefined

  for (const profile of company.regionProfiles) {
    if (profile.regionId === regionId) {
      if (profile.invoiceGroupingDefaults.length > 0) {
        invoiceGroupings = []
      }
      for (const defaults of profile.invoiceGroupingDefaults) {
        if (defaults.rateModelId === rateModel.id) {
          invoiceGroupings?.push(defaults);
        }
      }
      break;
    }
  }

  return invoiceGroupings;
};

export const useInvoiceGroupingDefaults = (props: UseInvoiceGroupingDefaultsProps): UseInvoiceGroupingDefaultsResult => {
  const {
    operator,
    truckCompany,
    rateModel
  } = props;

  // the invoice group defaults
  const [invoiceGroupingDefaults, setInvoiceGroupingDefaults] = useState<
    InvoiceGroupingDefaultEntity[] | undefined
  >(undefined);

  // we need the current region so we can get the correct company region profile
  const regionId = useOtsSelector<string | undefined>(getCurrentRegionId);

  // process the companies and get the default invoice grouping
  useEffect(() => {
    let appliedDefaults: InvoiceGroupingDefaultEntity[] | undefined = undefined;

    if (rateModel && regionId) {
      // first try operator
      if (operator) {
        appliedDefaults = findDefaults(operator, rateModel, regionId);
      }

      // fallback to truck company
      if (truckCompany && typeof appliedDefaults === 'undefined') {
        appliedDefaults = findDefaults(truckCompany, rateModel, regionId);
      }
    }

    setInvoiceGroupingDefaults(appliedDefaults);
  }, [operator, truckCompany, rateModel, regionId]);

  return {
    invoiceGroupings: invoiceGroupingDefaults
  };
};
